<template>
  <div :id="id">
  </div>
</template>

<script>
export default {
  name: "google-tag-display",
  props: {
    id: {
      type: String,
      required: true
    },
    slotRenderedEvent: {
      type: Function
    }
  },
  created: function () {
    googletag.cmd.push(() => {
      googletag.pubads().addEventListener('slotRenderEnded', (event) => {
        const slotId = event.slot.getSlotElementId();
        if (this.id === slotId && this.slotRenderedEvent) {
          this.slotRenderedEvent(event);
        }
      });
      googletag.display();
    });
  }
}
</script>
